"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GladiatorsBandageAbilityHandler = exports.GladiatorsBandageActorAbilityFactory = exports.GladiatorsBandageAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
class GladiatorsBandageAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.GladiatorsBandage;
        this.__typeName = "GladiatorsBandage";
    }
}
exports.GladiatorsBandageAbilityArgs = GladiatorsBandageAbilityArgs;
let GladiatorsBandageActorAbilityFactory = class GladiatorsBandageActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("GladiatorsBandage", "Self", 2);
    }
};
GladiatorsBandageActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("GladiatorsBandage")
], GladiatorsBandageActorAbilityFactory);
exports.GladiatorsBandageActorAbilityFactory = GladiatorsBandageActorAbilityFactory;
let GladiatorsBandageAbilityHandler = class GladiatorsBandageAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.applyHealing({
                    sequence,
                    animate: false,
                    healerId: ability.invokerId,
                    targetId: ability.invokerId,
                    amount: container.getPercentOfBaseHealth(ability.invokerId, 25),
                    attributePercent: 0,
                    onApplied: sequence => {
                        container.applyBuff({
                            sequence,
                            creatorId: ability.invokerId,
                            targetId: ability.invokerId,
                            duration: Duration_1.Duration.Turns(4),
                            effect: new core_1.RegenerationEffectArgs("Bandage", container.getPercentOfBaseHealth(ability.invokerId, 2))
                        });
                    }
                });
            }
        });
    }
};
GladiatorsBandageAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.GladiatorsBandage)
], GladiatorsBandageAbilityHandler);
exports.GladiatorsBandageAbilityHandler = GladiatorsBandageAbilityHandler;
